<app-page-header>
  <span class="page-title"
    ><h3>Notification</h3>
    <span>
      <a
        class="is-small is-link button i-want-highlight-this has-tooltip-left"
        id="createChat"
        data-tooltip="Create New Notification"
        [routerLink]="['/channels/newChannels']"
      >
        <i class="fa-solid fa-circle-plus"></i> </a></span
  ></span>
</app-page-header>
<div class="row">
  <div
    class="col-auto"
    [ngClass]="{ 'hide-listwrapper animated fadeIn': viewNotificatonList }"
  >
    <div class="col se-p second-level-menu right-box-shadow is-notification">
      @if (showSearchSec) {
      <div class="menu-options level is-marginless display-flex">
        <div class="level-left">
          <div class="level-item">
            <div class="select is-small">
              <select [(ngModel)]="sortBy" (change)="getPosts(0)">
                <option value="name">Sort A to Z</option>
                <option value="time">Sort by Recent</option>
              </select>
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="level-item">
            <a class="button is-small" (click)="showSearchbox('open')">
              <i class="fa fa-search"></i>
            </a>
            <!-- <a class="is-small button" [ngClass]="{'hideNewNotify': isUserRole != 1}" title="Create New Channels" [routerLink]="['/channels/newChannels']" >
              <i class=" fa-solid fa-circle-plus"></i>
            </a> -->
            <!-- <a class="is-small button" title="Create New Channels" [routerLink]="['/bulletineBoard/newbulletineboard']">
            <i class=" fa-solid fa-circle-plus"></i>
          </a> -->
          </div>
        </div>
      </div>
      } @if (!showSearchSec) {
      <div class="menu-options level is-marginless searchBox-pad display-flex">
        <div class="level-left">
          <div class="level-item input-search-box">
            <div class="field">
              <p class="control has-icons-left has-icons-right">
                <!-- <input class="input" type="text" inputFocus [(ngModel)]="searchNotification" (keyup.enter)="getPosts(0)" placeholder="Search here..."> -->
                <input
                  class="input"
                  type="text"
                  inputFocus
                  [(ngModel)]="searchNotification"
                  (keyup)="searchInList.next($event)"
                  placeholder="Search here..."
                />
                <!-- <a class="icon is-small is-left" (click)="getPosts(0)" title="Search"> -->
                <a class="icon is-small is-left" title="Search">
                  <i class="fa fa-search"></i>
                </a>
                <span class="input-bar"></span>
              </p>
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="level-item">
            <span
              class="icon is-small is-right search-return"
              (click)="showSearchbox('close')"
            >
              <i class="fa fa-times-circle"></i>
            </span>
          </div>
        </div>
      </div>
      }

      <div
        class="list-wrapper scroll-bar list-overflow scrollUserandGroup"
        #noficationList
        infinite-scroll
        appInfiniteScroll
        (reachedBottom)="fetchNextNotificationList()"
      >
        <ul class="notification-list">
          @for (data of postList; track data) {
          <li class="cursor-pointer user-status" routerLinkActive="active">
            <div
              class="columns is-gapless display-flex"
              [routerLink]="['/channels/', data.post_id]"
            >
              <div class="column is-clearfix pos-relative">
                <p
                  class="is-size-6 ellipsis list-active"
                  style="max-width: 235px"
                >
                  {{ data.post_name }}
                </p>
                @if (data.unread_post_count) {
                <span class="badge-count">{{ data.unread_post_count }}</span>
                }
                <div class="is-pulled-left">
                  <label class="is-size-7 text-clr-grey">{{
                    data.full_name
                  }}</label>
                </div>
                <div class="is-pulled-right">
                  <span class="is-size-7 text-clr-grey">
                    <small>{{ data.createdAt | date }}</small>
                  </span>
                </div>
              </div>
            </div>
          </li>
          }
          <pagination-loader
            [showFetchLoader]="showPaginateLoader"
          ></pagination-loader>
        </ul>
      </div>
    </div>
  </div>
  <div class="col ps-0" [ngClass]="{ 'ps-3': viewNotificatonList }">
    <router-outlet></router-outlet>
  </div>
</div>

<!-- <div class="empty-state" *ngIf="totalRowCount === 0">
<div class="has-text-centered box">
  <img [src]="'../../../../assets/images/notification_empty.svg'">
  <p>So nice to meet you, Stay tuned for exciting events heading YOUR way!</p>
  <button class="button mar-top15" (click)="newNotification()">
    <span class="icon">
      <i class="fa fa-plus"></i>
    </span>
    <span> Lesson Notification</span>
  </button>


</div>
</div> -->
